module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Weight unit","question":"What unit do you prefer for weight measurement?","grams":"Grams (g / kg)","pounds":"Pound (lb / oz)"},"de":{"title":"Gewichtseinheit","question":"Welche Einheit möchten sie für Gewichte nutzen?","grams":"Gramm (g / kg)","pounds":"Pfund (lb / oz)"}}')
  delete Component.options._Ctor
}
